import React, { useState, useEffect } from "react";
import { Button } from "./ui/button";
import { ShieldCheck } from "lucide-react";

const COOKIE_KEY = "contrack_cookie_consent";

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Cookie consent preference is intentionally non-sensitive (boolean flags + timestamp)
    // and is stored in localStorage per GDPR best practice for consent persistence.
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) setVisible(true);
  }, []);

  useEffect(() => {
    document.body.classList.toggle("cookie-banner-open", visible);
    return () => document.body.classList.remove("cookie-banner-open");
  }, [visible]);

  const handleAccept = (all) => {
    const consent = {
      essential: true,
      analytics: all,
      timestamp: new Date().toISOString(),
    };
    localStorage.setItem(COOKIE_KEY, JSON.stringify(consent));
    if (!all) {
      // Block analytics cookies by disabling any tracking scripts
      window.__contrack_analytics_blocked = true;
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[50] bg-white dark:bg-slate-900 border-t border-slate-200 dark:border-slate-700 shadow-lg pointer-events-auto"
      data-testid="cookie-consent-banner"
    >
      <div className="max-w-5xl mx-auto px-6 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <ShieldCheck size={24} className="text-slate-600 dark:text-slate-400 flex-shrink-0 mt-0.5 sm:mt-0" />
        <div className="flex-1">
          <p className="text-sm text-slate-700 dark:text-slate-300">
            We use <strong>essential cookies</strong> for authentication and security. Analytics cookies are optional and help us improve the platform. You can change your preferences at any time.
            {" "}
            <a href="/privacy" className="text-cyan-600 underline text-xs">Privacy Policy</a>
          </p>
        </div>
        <div className="flex gap-2 flex-shrink-0">
          <Button
            variant="outline"
            size="sm"
            className="rounded-sm text-xs"
            onClick={() => handleAccept(false)}
            data-testid="cookie-reject-analytics"
          >
            Essential Only
          </Button>
          <Button
            size="sm"
            className="rounded-sm text-xs bg-slate-900 hover:bg-slate-800 dark:bg-cyan-500 dark:text-slate-900"
            onClick={() => handleAccept(true)}
            data-testid="cookie-accept-all"
          >
            Accept All
          </Button>
        </div>
      </div>
    </div>
  );
}
